import { CollectionHero, HubTiles } from "@/components/CollectionHero";
import { ADDITIONAL_HUB } from "@/lib/additional";

export default function AdditionalHub() {
  return (
    <div data-testid="additional-hub">
      <CollectionHero
        crumbs={[
          { label: "Our Collection", to: "/collection" },
          { label: "Additional Collection" },
        ]}
        eyebrow={ADDITIONAL_HUB.eyebrow}
        title={ADDITIONAL_HUB.title}
        intro={ADDITIONAL_HUB.intro}
        hero={ADDITIONAL_HUB.hero}
      />
      <HubTiles items={ADDITIONAL_HUB.categories} columns="md:grid-cols-3" />
    </div>
  );
}
